import { render, staticRenderFns } from "./BaixaAdocao.vue?vue&type=template&id=45dc4f73"
import script from "./BaixaAdocao.vue?vue&type=script&lang=js"
export * from "./BaixaAdocao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports